import { render, staticRenderFns } from "./NotificationListingContainer.vue?vue&type=template&id=244d25f4"
import script from "./NotificationListingContainer.vue?vue&type=script&lang=js"
export * from "./NotificationListingContainer.vue?vue&type=script&lang=js"
import style0 from "./NotificationListingContainer.vue?vue&type=style&index=0&id=244d25f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports